import { Component, computed, Signal } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { PanelModule } from 'primeng/panel';
import { UserService } from '../../services/user.service';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';

@Component({
  selector: 'app-user-info',
  imports: [AvatarModule, TooltipModule, PopoverModule, PanelModule, BadgeModule, OverlayBadgeModule ],
  templateUrl: './user-info.component.html',
})
export class UserInfoComponent {
  initials:Signal<string>;
  name:Signal<string>;
  id:Signal<string>;
  jobTitle:Signal<string>;
  photo:Signal<string | undefined>;
  notify = false; // true shows the badge and the notification below
  notification = ''; // 'Incomplete timesheets! Click for more...';

  constructor(private user: UserService) {
    this.name = this.user.name
    this.initials = computed(() => this.getInitialsFromName(this.name()));
    this.id = computed(() => this.user.id() && `[${this.user.id()}]`);
    this.jobTitle = this.user.jobTitle;
    this.photo = this.user.photo;
  }

  getInitialsFromName(name: string) {
    return name.split(',')
      .map(part => part.trim().charAt(0))
      .reverse()
      .join('');
  }

}
